<template>
  <div class="accueil">
    <img alt="Vue logo" src="../assets/logo.png">

  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Accueil',
  components: {

  }
}
</script>
